import { render, staticRenderFns } from "./InformePDF.vue?vue&type=template&id=55f155ff&scoped=true&lang=pug"
import script from "./InformePDF.vue?vue&type=script&lang=js"
export * from "./InformePDF.vue?vue&type=script&lang=js"
import style0 from "./InformePDF.vue?vue&type=style&index=0&id=55f155ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f155ff",
  null
  
)

export default component.exports